<template>
  <v-container>
    <v-row no-gutters align="center" justify="center">
      <v-col cols="5">
        <Rules :gameId="gameId" />
      </v-col>
      <v-col>
        <WaitingPlayers :gameId="gameId" />
      </v-col>
    </v-row>
    <v-form>
      <v-btn width="100%" @click="startgame">Start Game!</v-btn>
    </v-form></v-container
  >
</template>

<script>
// @ is an alias to /src
import Rules from "./Rules.vue";
import WaitingPlayers from "./WaitingPlayers.vue";
import join_game from "./firebase/join_game";

export default {
  name: "CreateMenu",
  props: {
    gameId: String,
    playerKey: String,
  },
  created() {
    console.log("gameId", this.gameId);
    console.log("playerKey", this.playerKey);
  },
  methods: {
    async startgame() {
      console.log("A");
      await join_game.startGame(this.gameId);
    },
  },
  components: {
    Rules,
    WaitingPlayers,
  },
};
</script>
